module.exports = __webpack_public_path__ + "img/banner2.da054151.png";